import { render, staticRenderFns } from "./welfareDialog.vue?vue&type=template&id=beac0c00&scoped=true&"
import script from "./welfareDialog.vue?vue&type=script&lang=js&"
export * from "./welfareDialog.vue?vue&type=script&lang=js&"
import style0 from "./welfareDialog.vue?vue&type=style&index=0&id=beac0c00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac0c00",
  null
  
)

export default component.exports